import * as React from 'react';
import axios from 'axios';
import { API_BASE_URL } from '../../config';
import useNotification from '../notification/notificationContext';
import { NOTIFICATIONS } from '../../config';


export const AppointmentsContext = React.createContext();

function useAppointments() {
  const context = React.useContext(AppointmentsContext);
  if (!context) throw new Error('useAppointments must be used within an AppointmentsProvider');

  const [appointmentsState, dispatch] = context;
  
  const { setNotification } = useNotification();

  const getPatientAppointments = (source) => {
    return axios.get(`${API_BASE_URL}/appointments/patient`, { cancelToken: source.token }).then(res => {
      if (res.status === 200) return res; 
      return;
    }).catch(err => {
      if (axios.isCancel(err)) {
        return;
      } else {
        setNotification({
          show: true,
          type: NOTIFICATIONS.TYPE.WARNING_YELLOW,
          title: 'Server error',
          message: err.response?.data?.message || 'We were unable to retrieve appointments from the server. Please try again later.'
        })
        throw err;
      }
    })
  }

  const getPartnerAppointments = (source) => {
    return axios.get(`${API_BASE_URL}/appointments/partner`, { cancelToken: source.token }).then(res => {
      if (res.status === 200) return res; 
      return;
    }).catch(err => {
       if (axios.isCancel(err)) {
        return;
      } else {
        setNotification({
          show: true,
          type: NOTIFICATIONS.TYPE.WARNING_YELLOW,
          title: 'Server error',
          message: err.response?.data?.message || 'We were unable to retrieve appointments from the server. Please try again later.'
        })
        throw err;
      }
    })
  }

  const getTreatmentAppointments = (treatmentId) => {
    return axios.get(`${API_BASE_URL}/appointments/treatment/${treatmentId}`).then(res => {
      return res.data
    }).catch(err => {
      setNotification({
        show: true,
        type: NOTIFICATIONS.TYPE.WARNING_YELLOW,
        title: 'Server error',
        message: err.response?.data?.message || 'We were unable to retrieve appointments from the server. Please try again later.'
      })
      throw err;
    })
  }

  const addAppointment = (appointmentData) => {
    return axios.post(`${API_BASE_URL}/appointments/add`, appointmentData).then(res => {
      setNotification({
        show: true,
        type: NOTIFICATIONS.TYPE.SUCCESS,
        title: 'Success',
        message: 'Appointment added successfully'
      })
      return res.data
    }).catch(err => {
      setNotification({
        show: true,
        type: NOTIFICATIONS.TYPE.WARNING_YELLOW,
        title: 'Server error',
        message: 'We were unable to add appointment'
      })
      throw err;
    })
  }

  const getAppointmentDetails = (id) => {
    return axios.get(`${API_BASE_URL}/appointments/get-details/${id}`).then(res => {
      return res.data;
    }).catch(err => {
      setNotification({
        show: true,
        type: NOTIFICATIONS.TYPE.WARNING_YELLOW,
        title: 'Server error',
        message: 'We were unable to get appointment details. Please try again later.'
      })
      throw err;
    })
  }

  return {
    appointmentsState,  
    getTreatmentAppointments,
    addAppointment,
    getPatientAppointments,
    getPartnerAppointments,
    getAppointmentDetails
  }
}

export default useAppointments;